module.exports = __webpack_public_path__ + "img/parser.7d630d54.svg";